import React, { useEffect, useState } from "react"
import { Grid, Paper } from "@material-ui/core"
import {
  InputAsyncOptionMaster,
  InputCheckboxMaster,
  InputOptionMaster,
  InputTextMaster,
  MasterButton,
} from "App/Component/ui"
import {
  useInitialKelasKamarAplicares,
  useInitialSirsOnline,
  STYLE_DEFAULT_TAB_BED,
  ListTempatTidur,
  RESET_STATE_TAB_BED,
  useInitialJenisLayanan,
  useInitialKamar,
  getTagBedList,
  addTagBedList,
  deleteTagBedList,
  // useInitialRuangSirsOnline
} from "."
import {
  DEFAULT_SHOW_BUTTON_SUBMIT,
  DISABLED_BUTTON_SUBMIT,
  instance2,
  TYPE_INSTANCE2,
} from "App/constants"
import {
  defaultToastError,
  defaultToastSuccess,
  fetchData,
  getDifferentObjects,
  isNull,
} from "App/utils/helpers"

export default function FormTabBed({
  formData,
  setFormData,
  setNewData,
  ruangAplicare,
  selectRuangAplicare,
  setSelectRuangAplicare,
  golonganKelas,
}) {
  const [disabled, setDisabled] = useState(DEFAULT_SHOW_BUTTON_SUBMIT)

  const kelasKamarAplicares = useInitialKelasKamarAplicares()
  const sirsOnline = useInitialSirsOnline()
  // const ruangSirsOnline = useInitialRuangSirsOnline()

  const jenisLayanan = useInitialJenisLayanan()
  const kamar = useInitialKamar()
  const classes = STYLE_DEFAULT_TAB_BED()
  const [isLoadTag, setIsLoadTag] = useState(false)
  const [valueTag, setValueTag] = useState([])
  const addBed = async () => {
    return instance2.post("/bed/addbed", {
      ...formData,
      ruang_sirsonline: formData?.ruang_sirsonline,
      ruang_sirsonine_name: formData?.ruang_sirsonline_name,

      icekbridging: formData.icekbridging ? 1 : 0,
      status: formData.status ? 1 : 0,
      icekbridging_sirsonline:  formData.icekbridging_sirsonline ? 1 : 0,
    })
  }

  useEffect(() => {
    ;(async () => {
      if (!isNull(formData.id)) {
        await handleGetTagBed()
      }
    })()
  }, [formData.id]) // eslint-disable-line react-hooks/exhaustive-deps

  const updateBed = () => {
    return instance2.post(
      "/bed/updatebed",
      {
        ...formData,
        ruang_sirsonline: formData?.ruang_sirsonline,
        ruang_sirsonine_name: formData?.ruang_sirsonline_name,

        icekbridging: formData.icekbridging ? 1 : 0,
        status: formData.status ? 1 : 0,
        icekbridging_sirsonline:  formData.icekbridging_sirsonline ? 1 : 0,
      },
      {
        headers: {
          idbed: formData.id,
        },
      },
    )
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    setDisabled(DISABLED_BUTTON_SUBMIT)
    if (formData.name === "") {
      setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT)
      defaultToastError("Nama tidak boleh kosong")
    } else {
      try {
        if (formData.id === "") {
          await addBed()
          defaultToastSuccess("Berhasil menambah bed")
        } else if (formData.id !== "") {
          await updateBed()
          defaultToastSuccess("Berhasil mengubah bed")
        }
        await setNewData()
        setFormData(RESET_STATE_TAB_BED)
        setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT)
      } catch (error) {
        setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT)
        defaultToastError(error?.response?.data?.message)
      }
    }
  }

  const handleChange = (text) => (e) => {
    setFormData({
      ...formData,
      [text]: e.target.value,
    })
  }

  const handleChangeGolKelas = (e) => {
    if (isNull(e)) {
      setFormData({
        ...formData,
        gol_golongankelasaplicares: null,
        gol_golongankelasaplicares_name: "Pilih Gol Kelas Aplicares",
      })
    } else {
      const kodeRuangAplicare = golonganKelas.filter(
        (item) => item.value === e.value,
      )

      if (!isNull(kodeRuangAplicare[0].kode_ruang_aplicares)) {
        const _temp = []
        ruangAplicare[0].map((item) => {
          const check = kodeRuangAplicare[0].kode_ruang_aplicares
            .split(",")
            .filter((e) => e === item.kode)
          if (check.length > 0) {
            _temp.push({
              id:  item.id,
              value: item.kode,
              label: `[${item.kode}] ${item.name}`,
              name: `(${item.id}) ${item.name}`,
            })
          }
          return true
        })

        setSelectRuangAplicare(_temp)
      }

      setFormData({
        ...formData,
        gol_golongankelasaplicares: e?.value,
        gol_golongankelasaplicares_name: e?.label,
      })
    }
  }

  const preLoadData = async (inputValue) => {
    const valueState = valueTag
    const res = await fetchData(TYPE_INSTANCE2, "/bed/get-ms-bed-tag", "body", {
      params: {
        kategori_tag: "BED",
        nama: inputValue,
      },
    })

    if (res) {
      const data = []
      res.map((item) => {
        return data.push({
          value: item["id"],
          label: item["text"],
          color: isNull(item["color"]) ? "#000000" : item["color"],
        })
      })

      return data.filter((bo) =>
        valueState.every((ao) => ao.label !== bo.label),
      )
    }
  }
  // const tagOption = useSelectMultipelOption(
  //   true,
  //   "/bed/get-ms-bed-tag",
  //   TYPE_INSTANCE2,
  //   "id",
  //   "text",
  //   "body",
  //   {
  //     params: {
  //       kategori_tag: "BED",
  //       nama:'',
  //     },
  //   },
  //   valueTag,
  //   undefined,
  //   "label",
  //   "text",
  //   true,
  //   "color"
  // );

  const handleGetTagBed = async () => {
    setIsLoadTag(true)
    if (isNull(formData.id)) {
      defaultToastError("Harap pilih Bed terlebih dahulu")
    } else {
      const res = await getTagBedList(formData.id)
      if (res.state) {
        // setListTag(res.data);
        handleReCreateValueTag(res.data)
        setIsLoadTag(false)
        return true
      } else {
        defaultToastError(res.message)
        setIsLoadTag(false)
      }
    }
  }

  const handleAddTagBed = async (e) => {
    setIsLoadTag(true)
    if (isNull(formData.id)) {
      defaultToastError("Harap pilih Bed terlebih dahulu")
      return false
    } else {
      const data = {
        id_bed: formData.id,
        id_bed_tag: e.value,
        remark: "",
        nama_tag: e.label,
      }
      const res = await addTagBedList(data)
      if (res.state) {
        handleGetTagBed()
      } else {
        defaultToastError(res.message)
        setIsLoadTag(false)
      }
    }
  }

  const handleDeleteTagBed = async (e) => {
    setIsLoadTag(true)
    if (isNull(formData.id)) {
      defaultToastError("Harap pilih Bed terlebih dahulu")
      return false
    } else {
      const data = {
        id: e.value,
      }
      const res = await deleteTagBedList(data)
      if (res.state) {
        handleGetTagBed()
      } else {
        defaultToastError(res.message)
        setIsLoadTag(false)
      }
    }
  }

  const handleCreateTagBed = async (inputValue) => {
    setIsLoadTag(true)
    if (isNull(formData.id)) {
      defaultToastError("Harap pilih Bed terlebih dahulu")
      return false
    }
    const data = {
      id_bed: formData.id,
      id_bed_tag: "",
      remark: "",
      nama_tag: inputValue,
    }
    const res = await addTagBedList(data, true)
    if (res.state) {
      handleGetTagBed()
    } else {
      defaultToastError(res.message)
      setIsLoadTag(false)
    }
  }

  const handleReCreateValueTag = (data) => {
    const newData = data.reduce(
      (result, item) => [
        ...result,
        {
          value: item.id,
          label: item.nama_tag,
          color: isNull(item?.color) ? "#000000" : item?.color,
        },
      ],
      [],
    )
    setValueTag(newData)
  }

  const checkAction = (value) => {
    const lengOldData = valueTag.length
    const lengNewData = value.length
    let difference = getDifferentObjects(valueTag, value)
    if (difference.length !== 0) {
      if (lengNewData > lengOldData) {
        handleAddTagBed(difference[0])
      } else {
        handleDeleteTagBed(difference[0])
      }
    } else {
      defaultToastError("Terjadi Kesalahan Saat Memperbarui Data !")
      setIsLoadTag(false)
    }
  }

  return (
    <Paper className={classes.paper}>
      <form onSubmit={(e) => handleSubmit(e)}>
        <Grid container spacing={3}>
          <Grid item xs={12} sm={5}>
            <Grid
              container
              direction="row"
              justifyContent="space-between"
              alignItems="center"
            >
              <div>
                <p>ID TEMPAT TIDUR</p>
                <div
                  style={{
                    paddingTop: "1rem",
                    fontWeight: "600",
                    fontSize: "20px",
                  }}
                >
                  {formData.id === "" ? "-" : formData.id}
                </div>
              </div>
            </Grid>
            <br />

            <Grid container spacing={1}>
              <InputTextMaster
                type="hidden"
                name="id"
                id="id"
                readOnly={true}
                value={formData.id}
              />
              <Grid item sm={12}>
                <InputTextMaster
                  name="name"
                  label="NAMA"
                  id="name"
                  placeholder="Nama Ruang dan Nomor Tempat Tidur"
                  value={formData.name}
                  onChange={handleChange("name")}
                />
              </Grid>
              <Grid item sm={12}>
                <InputOptionMaster
                  name="kelas-kamar-aplicares"
                  label="KELAS KAMAR APLICARES"
                  id="kelas-kamar-aplicares"
                  withSearch={true}
                  data={kelasKamarAplicares}
                  value={formData.kelas_id}
                  labelValue={formData.kelas_name}
                  onChange={(e) => {
                    if (isNull(e)) {
                      setFormData({
                        ...formData,
                        kelas_id: null,
                        kelas_name: "Pilih Kelas Kamar",
                      })
                    } else {
                      setFormData({
                        ...formData,
                        kelas_id: e?.value,
                        kelas_name: e?.label,
                      })
                    }
                  }}
                />
              </Grid>
              <Grid item sm={12}>
                <InputOptionMaster
                  name="kelas-kamar-sirs-online"
                  label="KELAS KAMAR SIRS ONLINE"
                  id="kelas-kamar-sirs-online"
                  withSearch={true}
                  data={sirsOnline}
                  value={formData.kelaskamarsirsonline}
                  labelValue={formData.kelaskamarsirsonline_name}
                  onChange={(e) => {
                    if (isNull(e)) {
                      setFormData({
                        ...formData,
                        kelaskamarsirsonline: null,
                        kelaskamarsirsonline_name:
                          "Pilih Kelas Kamar Sirs Online",
                      })
                    } else {
                      setFormData({
                        ...formData,
                        kelaskamarsirsonline: e?.value,
                        kelaskamarsirsonline_name: e?.label,
                      })
                    }
                  }}
                />
              </Grid>
              <Grid item sm={12}>
                <InputOptionMaster
                  name="gol_golongankelasaplicares"
                  label="GOL. KELAS APLICARES"
                  id="gol_golongankelasaplicares"
                  withSearch={true}
                  data={golonganKelas}
                  value={formData.gol_golongankelasaplicares}
                  labelValue={formData.gol_golongankelasaplicares_name}
                  onChange={(e) => handleChangeGolKelas(e)}
                />
              </Grid>

              <Grid item sm={12}>
                <InputOptionMaster
                  name="ruang_aplicares"
                  label="RUANG APLICARES"
                  id="ruang_aplicares"
                  withSearch={true}
                  data={selectRuangAplicare}
                  value={formData.ruang_aplicares}
                  labelValue={formData.ruang_aplicares_name}
                  onChange={(e) => {
                    if (isNull(e)) {
                      setFormData({
                        ...formData,
                        ruang_aplicares: null,
                        ruang_aplicares_name: "Pilih Gol Kelas Aplicares",
                      })
                    } else {
                      setFormData({
                        ...formData,
                        ruang_sirsonline: e?.id,
                        ruang_sirsonline_name: e?.name,
                        ruang_aplicares: e?.value,
                        ruang_aplicares_name: e?.label,
                      })
                    }
                  }}
                />
              </Grid>

              {/* <Grid item sm={12}>
                <InputOptionMaster
                  name="ruang_sirsonline"
                  label="RUANG SIRS ONLINE"
                  id="ruang_sirsonline"
                  withSearch={true}
                  data={ruangSirsOnline}
                  value={formData.ruang_sirsonline}
                  labelValue={formData.ruang_sirsonline_name}
                  onChange={(e) => {
                    if (isNull(e)) {
                      setFormData({
                        ...formData,
                        ruang_sirsonline: null,
                        ruang_sirsonline_name: "Pilih Ruang Sirs Online",
                      })
                    } else {
                      setFormData({
                        ...formData,
                        ruang_sirsonline: e?.value,
                        ruang_sirsonline_name: e?.label,
                      })
                    }
                  }}
                />
              </Grid> */}
            </Grid>

            <Grid container spacing={1}>
              <Grid item sm={12}>
                <InputOptionMaster
                  name="kamar"
                  label="KAMAR"
                  id="kamar"
                  withSearch={true}
                  data={kamar}
                  value={formData.kamar_id}
                  labelValue={formData.kamar_name}
                  onChange={(e) => {
                    if (isNull(e)) {
                      setFormData({
                        ...formData,
                        kamar_id: null,
                        kamar_name: "Pilih Kamar",
                      })
                    } else {
                      setFormData({
                        ...formData,
                        kamar_id: e?.value,
                        kamar_name: e?.label,
                      })
                    }
                  }}
                />
              </Grid>
              <Grid item sm={12}>
                <InputOptionMaster
                  name="layanan"
                  label="TEMPAT TIDUR RL"
                  id="layanan"
                  withSearch={true}
                  data={jenisLayanan}
                  value={formData.jenis_layanan_id}
                  labelValue={formData.jenis_layanan_name}
                  onChange={(e) => {
                    if (isNull(e)) {
                      setFormData({
                        ...formData,
                        jenis_layanan_id: null,
                        jenis_layanan_name: "Pilih Jenis Layanan",
                      })
                    } else {
                      setFormData({
                        ...formData,
                        jenis_layanan_id: e?.value,
                        jenis_layanan_name: e?.label,
                      })
                    }
                  }}
                />
              </Grid>

              <Grid item sm={4}>
                <InputCheckboxMaster
                  checked={formData.icekbridging}
                  name="icekbridging"
                  id="icekbridging"
                  label="Bridging Aplicare"
                  onChange={() =>
                    setFormData({
                      ...formData,
                      icekbridging: !formData.icekbridging,
                    })
                  }
                />
              </Grid>
              <Grid item sm={4}>
                <InputCheckboxMaster
                  checked={formData.status}
                  name="status"
                  id="status"
                  label="Aktif"
                  onChange={() =>
                    setFormData({
                      ...formData,
                      status: !formData.status,
                    })
                  }
                />
              </Grid>
              <Grid item sm={4}>
                <InputCheckboxMaster
                  checked={Boolean(formData.icekbridging_sirsonline)}
                  name="icekbridging_sirsonline"
                  id="icekbridging_sirsonline"
                  label="Bridging Sirs Online"
                  onChange={() =>
                    setFormData({
                      ...formData,
                      icekbridging_sirsonline: !formData.icekbridging_sirsonline ? 1 : 0,
                    })
                  }
                />
              </Grid>

            </Grid>
          </Grid>
          <Grid item xs={12} sm={7}>
            <ListTempatTidur formData={formData} setFormData={setFormData} />
            <Paper className="mt-1 p-1">
              <InputAsyncOptionMaster
                name="tagBed"
                label="TAG BED"
                id="tagBed"
                loadOptions={preLoadData}
                // data={tagOption}
                isMulti
                value={isNull(formData.id) ? [] : valueTag}
                labelValue={isNull(formData.id) ? [] : valueTag}
                // defaultData={formData.jasa}
                options
                onChange={checkAction}
                onCreateOption={handleCreateTagBed}
                disabled={isNull(formData.id) ? true : isLoadTag}
                isLoading={isLoadTag}
                creatable={true}
                isClearable={false}
                isColored={true}
              />
            </Paper>
          </Grid>
        </Grid>

        <div className="mt-2">
          <hr style={{ margin: "1rem 0", opacity: "0.3" }} />
          <Grid
            container
            direction="row"
            justifyContent="space-between"
            alignItems="center"
          >
            <MasterButton
              outline={true}
              type={"button"}
              color="danger"
              name="Reset"
              size="md"
              onClick={() => setFormData(RESET_STATE_TAB_BED)}
            />
            <MasterButton
              outline={false}
              type={"submit"}
              color={disabled.color}
              name={disabled.label}
              size="md"
            />
          </Grid>
        </div>
      </form>
    </Paper>
  )
}
